import React from "react";

const Reports = ({
  color = "blue",
  viewBox = "0 0 19 22",
  width = 20,
  height = 20,
  ...rest
}) => {
  const fillColor = color => {
    switch (color) {
      case "orange":
        return "#E5A51D";
      case "blue":
        return "#2D75AD";
      default:
        return color;
    }
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      height={height}
      width={width}
      {...rest}
    >
      <path
        fill={fillColor(color)}
        d="M0 10.453h4.47V5.807H0v4.646zM1.9 22h2.57v-4.646H0v2.733C0 21.144.85 22 1.9 22zM0 4.646h4.47V0H1.9C.85 0 0 .856 0 1.913v2.733zm5.588 5.807H19V5.807H5.588v4.646zM0 16.193h4.47v-4.646H0v4.646zm5.588 0H19v-4.646H5.588v4.646zm0 5.807H17.1c1.05 0 1.9-.856 1.9-1.913v-2.733H5.588V22zm0-22v4.646H19V1.913C19 .856 18.15 0 17.1 0H5.588z"
      />
    </svg>
  );
};

export default Reports;
